import { CommonModule } from '@angular/common';
import { Component, Input, Pipe, PipeTransform } from '@angular/core';
import { Icon } from '../../icons';
import { IconComponent } from '../../icons/icon/icon.component';
import { FilterKey } from '../filter.interface';

const DEFAULT_ICON = 'griddy-check-circle';
const FILTER_ICON_MAP: Record<FilterKey, Icon> = {
  [FilterKey.Business]: DEFAULT_ICON,
  [FilterKey.Columns]: DEFAULT_ICON,
  [FilterKey.Currency]: 'griddy-currency',
  [FilterKey.Date]: 'griddy-calendar-date',
  [FilterKey.HideUnlisted]: 'griddy-eye-off-line',
  [FilterKey.Host]: 'griddy-user-circle',
  [FilterKey.IncludeUnlisted]: 'griddy-eye-line',
  [FilterKey.ListingCity]: 'griddy-location-pin',
  [FilterKey.ListingCountry]: 'griddy-location-pin',
  [FilterKey.Platform]: 'griddy-laptop',
  [FilterKey.Property]: 'griddy-home',
  [FilterKey.ReservationStatus]: DEFAULT_ICON,
  [FilterKey.Tag]: 'griddy-tag',
  [FilterKey.TaskType]: 'griddy-clipboard-list',
  [FilterKey.Teammate]: 'griddy-user',
};

@Pipe({
  name: 'filtersIcon',
  standalone: true,
})
export class FiltersIconPipe implements PipeTransform {
  transform(value: FilterKey): Icon {
    return FILTER_ICON_MAP[value] ?? DEFAULT_ICON;
  }
}

@Component({
  selector: 'ui-filter-icon',
  standalone: true,
  imports: [CommonModule, IconComponent, FiltersIconPipe],
  templateUrl: './filter-icon.component.html',
  styles: [],
})
export class FilterIconComponent {
  @Input({ required: true }) filterKey!: FilterKey;
}
